<template>
  <div class="box">
    <!-- <img :src="img" alt="" srcset="" /> -->
    <div class="icon1"></div>
    <piecharts class="chart" :info="info1"></piecharts>
    <piecharts class="chart" :info="info2"></piecharts>
  </div>
</template>

<script>
import img from "../img/5.png";

import piecharts from "../charts/pie.vue";
// import cfg from "./config.js";
export default {
  components: { piecharts },
  props: [],
  data() {
    return {
      img,
      info1: {
        pie: 25,
        key: "温度",
        val: 36.5,
        unit: "℃",
      },
      info2: {
        pie: 90,
        key: "湿度",
        val: 90,
        unit: "%",
      },
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
  width: 100%;
  left: 0;
  top: -0.04rem;
  z-index: 0;
}
.box {
  height: 0.4rem;
  overflow: hidden;
}
.icon1 {
  font-size: 0.14rem;
  color: #0f69ca;
  width: 0.3rem;
  height: 0.14rem;
  margin-top: 0.12rem;
  margin-left: 0.12rem;
  float: left;
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  background-image: url(../img/wdsd.png);
  border-right: 1px solid rgba($color: #0f69ca, $alpha: 0.5);
}
.chart {
  margin-top: 0.06rem;
  margin-left: 0.17rem;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/data/wendushidu.vue